import api from "./api";
import {mapHolidayDto} from "../dto/HolidayDTO";


export const getHolidayEntries = async ({role, userId}) => {
    try {
        const url = `/holiday/user/${userId}`;
        const res =
            role === 'admin'
                ? await api.get('/holiday')
                : await api.get(url);
        return res.data.map(mapHolidayDto);
    } catch (err) {
        console.error("Error getting holiday:", err);
        throw err;
    }
};

export const createHoliday = async ({UserId, startDate, endDate, numberDays}) => {
    try {
        const res = await api.post('/holiday', {UserId, startDate, endDate, numberDays});
        return res.data;
    } catch (err) {
        console.error("Error creating Holiday:", err);
        throw err;
    }
}

export const updateHoliday = async (id, {UserId, startDate, endDate, numberDays}) => {
    try {
        const res = await api.patch(`/holiday/${id}`, {UserId, startDate, endDate, numberDays});
        return res.data;
    } catch (err) {
        console.error("Error updating Holiday:", err);
        throw err;
    }
}

export const deleteHoliday = async (id) => {
    try {
        const res = await api.delete(`/holiday/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting Holiday:", err);
        throw err;
    }
}
